import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Script} from '../../../../types';

type ScriptsProps = {
  scripts: Nullable<Script[]>
}

const Scripts: FC<ScriptsProps> = ({
  scripts
}) => {
  const {t} = useTranslation(['tasks']);

  if (!scripts?.length) {
    return null;
  }

  return (
    <section className="task-description__section">
      <h4 className="title">{t('currentTask.description.popup.scriptsLabel')}</h4>
      <ul className="task-description__list">
        {scripts.map(({id, message, resourceLink}) => (
          <li className="task-description__item" key={id.toString()}>
            {resourceLink ? (
              <a
                href={resourceLink || ''}
                target="_blank"
                className="link"
                rel="noopener noreferrer"
              >
                {message}
              </a>
            ) : message}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Scripts;
